export default __webpack_public_path__ + "static/media/Refined Elixir of Mystical Replenishment.0bfb243d.jpg";